import withAPIAction from 'helpers/withAPIAction'
import {
  MemberPointListReq,
  AdjustMemberPointListReq,
  PointConfigDetailReq,
  UpdatePointConfigReq,
  DeltePointConfigReq,
  MemberListReq,
  MemberDetailReq,
  UpdateMemberReq,
  MemberPoinInfoReq,
  EarnPointHistoryReq,
  BurnPointHistoryReq,
  AllMemberEarnPointHistoryReq,
  AllBurnPointHistoryReq,
} from './types'
import {
  getMemberPointListAction,
  adjustMemberPointAction,
  getPointConfigDetailAction,
  updateConfigPointAction,
  deleteConfigPointAction,
  //member page
  getMemberListAction,
  getMemberDetailAction,
  updateMemberAction,
  getMemberPointInfoAction,

  //history
  getEarnPointHistoryAction,
  getBurnPointHistoryAction,
  getAllEarnPointHistoryAction,
  getAllBurnPointHistoryAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const memberPointListAPI = (data: MemberPointListReq, token: string, xmid: string) => {
  return withAPIAction<MemberPointListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.memberPointList,
    data,
    token,
    xmid,
  })(getMemberPointListAction)
}

export const adjustMemberPointAPI = (data: AdjustMemberPointListReq, token: string, xmid: any) => {
  const endPoint = APIPath.adjustMemberPoint.replace(':id', data.id.toString())
  return withAPIAction<AdjustMemberPointListReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(adjustMemberPointAction)
}

export const getPointConfigDetailAPI = (data: PointConfigDetailReq, token: string, xmid: string) => {
  return withAPIAction<PointConfigDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getDetailConfigPoint,
    data,
    token,
    xmid,
  })(getPointConfigDetailAction)
}

export const updateConfigPointAPI = (data: UpdatePointConfigReq, token: string, xmid: any) => {
  return withAPIAction<UpdatePointConfigReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateConfigPoint,
    data,
    token,
    xmid,
  })(updateConfigPointAction)
}

export const deleteConfigPointAPI = (data: DeltePointConfigReq, token: string, xmid: any) => {
  const endPoint = APIPath.deleteConfigPoint.replace(':id', data.id.toString())
  return withAPIAction<DeltePointConfigReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteConfigPointAction)
}

export const getMemberListAPI = (data: MemberListReq, token: string, xmid: string) => {
  return withAPIAction<MemberListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getMemberList,
    data,
    token,
    xmid,
  })(getMemberListAction)
}

export const getMemberDetailAPI = (data: MemberDetailReq, token: string, xmid: any) => {
  const endPoint = APIPath.getMemberDetail.replace(':id', data.id.toString())
  return withAPIAction<MemberDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getMemberDetailAction)
}

export const updateMemberAPI = (data: UpdateMemberReq, token: string, xmid: any) => {
  const endPoint = APIPath.updateMember.replace(':id', data.id.toString())
  return withAPIAction<UpdateMemberReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateMemberAction)
}

export const getMemberPointInfoAPI = (data: MemberPoinInfoReq, token: string, xmid: any) => {
  const endPoint = APIPath.getMemberPointInfo.replace(':id', data.id.toString())
  return withAPIAction<MemberPoinInfoReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getMemberPointInfoAction)
}

export const getEarnPointHistoryAPI = (data: EarnPointHistoryReq, token: string, xmid: any) => {
  return withAPIAction<EarnPointHistoryReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getEarnPointHistory,
    data,
    token,
    xmid,
  })(getEarnPointHistoryAction)
}

export const getBurnPointHistoryAPI = (data: BurnPointHistoryReq, token: string, xmid: any) => {
  return withAPIAction<BurnPointHistoryReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getBurnPointHistory,
    data,
    token,
    xmid,
  })(getBurnPointHistoryAction)
}

export const getAllEarnPointHistoryAPI = (data: AllMemberEarnPointHistoryReq, token: string, xmid: any) => {
  return withAPIAction<AllMemberEarnPointHistoryReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getAllEarnPointHistory,
    data,
    token,
    xmid,
  })(getAllEarnPointHistoryAction)
}

export const getAllBurnPointHistoryAPI = (data: AllBurnPointHistoryReq, token: string, xmid: any) => {
  return withAPIAction<AllBurnPointHistoryReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getALlBurnPointHistory,
    data,
    token,
    xmid,
  })(getAllBurnPointHistoryAction)
}
